import React from 'react';

import { ADMIN_GROUP_PAGE } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { GroupIcon } from '@Generic/icons';

const GroupsPage = React.lazy(() => import('../../../pages/Admin/GroupsPage'));

export default {
  label: 'admin-page.groups.title',
  group: ADMIN,
  to: '/administration/company/groups',
  route: '/administration/company/groups',
  area: ADMIN_GROUP_PAGE,
  component: GroupsPage,
  icon: <GroupIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_GROUP_PAGE,
  hasNavBar: true,
};
